<template>
  <el-dialog
    :model-value="modelValue"
    title="Historial de Versiones"
    width="550px"
    :close-on-click-modal="false"
    @update:model-value="$emit('update:modelValue', $event)"
    @open="fetchData"
  >
    <div style="margin-bottom: 15px; color: #606266">
      Mostrando el historial de la Especificación Técnica Base <b>{{ codigoBase }}</b>
    </div>

    <el-table
      v-loading="loading"
      :data="historialVersiones"
      border
      stripe
      size="small"
      style="width: 100%"
    >
      <el-table-column
        prop="Version"
        label="Ver."
        width="70"
        align="center"
      >
        <template #default="scope">
          <b>V{{ scope.row.Version }}</b>
        </template>
      </el-table-column>

      <el-table-column
        prop="FechaCreacion"
        label="Fecha"
        width="120"
        align="center"
      >
        <template #default="scope">
          {{ getDate('dd/mm/yyyy', scope.row.FechaCreacion) }}
        </template>
      </el-table-column>

      <el-table-column
        label="Estado"
        min-width="120"
        align="center"
      >
        <template #default="scope">
          <el-tag
            :type="
              scope.row.CicloVida === 'Vigente'
                ? 'success'
                : scope.row.CicloVida === 'Borrador'
                  ? 'warning'
                  : scope.row.CicloVida === 'Obsoleta'
                    ? 'info'
                    : 'danger'
            "
            size="small"
            effect="dark"
          >
            {{ scope.row.CicloVida }}
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column
        label="Acción"
        width="100"
        align="center"
      >
        <template #default="scope">
          <el-button
            type="primary"
            link
            size="small"
            :disabled="scope.row.Codigo === codigoActual"
            @click="goToVersion(scope.row.Codigo)"
          >
            {{ scope.row.Codigo === codigoActual ? 'Actual' : 'Ver' }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <template #footer>
      <el-button @click="$emit('update:modelValue', false)">Cerrar</el-button>
    </template>
  </el-dialog>
</template>

<script setup>
import { ref } from 'vue';
import { useTechnicalSpecificationStore } from '@/views/technical_specifications/stores/technical_specification_store.js';
import getDate from '@/shared/components/utils.js';
import { useRouter } from 'vue-router';

const router = useRouter();
const props = defineProps({
  modelValue: { type: Boolean, default: false },
  codigoBase: { type: Number, required: true },
  codigoActual: { type: Number, required: true },
});

const emit = defineEmits(['update:modelValue']);
const technicalSpecificationStore = useTechnicalSpecificationStore();
const historialVersiones = ref([]);
const loading = ref(false);

const fetchData = async () => {
  if (!props.codigoBase) return;
  loading.value = true;
  try {
    historialVersiones.value = await technicalSpecificationStore.getHistorialVersionesHTTP(
      props.codigoBase,
    );
  } catch (error) {
    console.error('Error al obtener el historial', error);
  } finally {
    loading.value = false;
  }
};

const goToVersion = (codigoET) => {
  if (codigoET === props.codigoActual) return;
  emit('update:modelValue', false);
  router.push(`/page/technical-specifications/edit/${codigoET}`);
};
</script>
